module.exports = __webpack_public_path__ + "static/img/addcy.ee30bde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/addcy.jpg
// module id = 5gWA
// module chunks = 1